module.exports = __webpack_public_path__ + "img/facebook_black.e50465bb.png";